import { uniqBy, find } from "lodash";

import InsightsApi from "../../api/InsightsApi";
import { CSVExport, PdfImageExport } from "../../utils/exports";

import moment from "moment";
import { transformChartData } from "./DataTransformer";
import { mockChartSummary } from "./driverSafetyMockData";
import {
  CHART_UTILISATION,
  OVER_UTILISED,
  UNDER_UTILISED,
  ACCEPTABLE,
  CHART_SCATTER_PLOT,
  VEHICLE_UTILISATION_GRAPH,
  ELAPSED_LEASE_PERCENT,
  DRIVER_SAFETY_DETAILED_VIEW,
  DUE_REPORT_REGEX
} from "./const.js";

export const getData = (options, cb, getGraphDataDoneCb, actions) => {
  // reset both error & data object prior to api call
  cb(null, {
    data: {}
  }, true);

  // console.log({ getData: { options, cb, getGraphDataDoneCb } });
  if(actions && actions.setFetchGraphData)
    actions.setFetchGraphData(true);

  InsightsApi.getGraphData(options)
    .then(data => {
      // data = mockChartSummary;
      if (data) {
        const formatedData = transformChartData(data);

        const title = data.Title;
        formatedData.ChartType = data.ChartType;
        const notification = data.Notifications;

        cb(null, {
          data: formatedData,
          title,
          notification,
          fetched: true,
        });
      } else {
        console.log("InsightsApi.getGraphData data error");
      }

      if (getGraphDataDoneCb) getGraphDataDoneCb();
    })
    .catch(error => {
      console.log("InsightsApi.getGraphData error", error);

      // add error data callback for InsightChart.js
      cb(error, { data: {} });

      if (getGraphDataDoneCb) getGraphDataDoneCb();
    });
};

export const isDataEmpty = data => {
  if (data && data.series) {
    return data.series.length === 0 || !data.series[0].name;
  } else if (data.ChartType === "chartScatterPlot") {
    return data.Data.length === 0;
  }
  return true;
};

const getCSVFileName = options => {
  return `Data-${options.id}.csv`;
};

const getFileName = options => {
  let name = "";
  switch (options) {
    case "application/pdf":
      name = `chart.pdf`;
      break;
    case "image/jpeg":
      name = `chart.jpeg`;
      break;
  }
  return name;
};

export const exportData = options => {
  InsightsApi.exportGraphData(options)
    .then(data => {
      if (data) {
        console.log(data);
        CSVExport(data, getCSVFileName(options));
        // const csvData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        //
        // if (window.navigator.msSaveBlob) {
        //   window.navigator.msSaveBlob(csvData, getCSVFileName(options));
        // } else {
        //   const csvURL = window.URL.createObjectURL(csvData);
        //   const link = document.createElement('a');
        //   link.setAttribute('target', '_blank');
        //   document.body.appendChild(link);
        //   link.href = csvURL;
        //   link.download = getCSVFileName(options);
        //   link.click();
        //   //adding some delay in removing the dynamically created link solved the problem in FireFox
        //   setTimeout(() => {
        //     window.URL.revokeObjectURL(link);
        //   }, 0);
        // }
      } else {
        console.log("InsightsApi.exportGraphData error");
      }
    })
    .catch(error => {
      console.log("InsightsApi.exportGraphData error", error);
    });
};

export const exportDocument = (svg, options) => {
  InsightsApi.exportDocument(svg, options)
    .then(data => {
      if (data) {
        PdfImageExport(data, getFileName(options.type), options.type);
      } else {
        console.log("InsightsApi.exportDocument error");
      }
    })
    .catch(error => {
      console.log("InsightsApi.exportDocument error", error);
    });
};

//Insights Table helpers

export const getChartUtilisationCategoryStyle = category => {
  switch (category) {
    case OVER_UTILISED:
      return "negative";

    case ACCEPTABLE:
      return "base2";

    case UNDER_UTILISED:
      return "under";

    default:
      return "";
  }
};

export const shouldEnableDetails = chartType => {
  return chartType === CHART_SCATTER_PLOT ? true : false;
};

export const shouldEnableInsightDetailFilters = chartType => {
  return chartType === CHART_SCATTER_PLOT || DRIVER_SAFETY_DETAILED_VIEW
    ? false
    : true;
};

export const getInsightTableMultipleCategoryHeading = (title) => {
  DUE_REPORT_REGEX.lastIndex = 0;
  if( DUE_REPORT_REGEX.test(title) )
    return "Due";

  switch (title) {
    case VEHICLE_UTILISATION_GRAPH:
      return ELAPSED_LEASE_PERCENT;
    default:
      return "Month";
  }
};

export const getActiveInsight = (items, id) => {
  if (!items) {
    return;
  }

  for (const item of items) {
    // Test current object
    if (item.id === id) {
      return item;
    }

    // Test children recursively
    const child = getActiveInsight(item.children, id);
    if (child) {
      return child;
    }
  }
};



// WEBPACK FOOTER //
// ./src/features/insights/helpers.js